import { trackCustomEvent } from 'app/utils/statistics/clientStatistics';
import { toggleEpisodePicker } from 'app/utils/statistics/customEvents';
import React from 'react';
import { StyledToggle } from './EpisodePicker.styles';
import SvgIcon, { SVG_ICONS } from 'app/ui-components/SvgIcon/SvgIcon';

const EpisodePickerButton = ({ displayEpisodePicker, setDisplayEpisodePicker, playedPercentage }) => {
    const handleClick = () => {
        setDisplayEpisodePicker(!displayEpisodePicker);
        trackCustomEvent(toggleEpisodePicker(!displayEpisodePicker, playedPercentage));
    };

    if (displayEpisodePicker) {
        return (
            <StyledToggle onClick={handleClick} displayEpisodePicker>
                <span>Dölj avsnitt</span>
            </StyledToggle>
        );
    }

    return (
        <StyledToggle onClick={handleClick}>
            <SvgIcon icon={SVG_ICONS.PLAYLIST} width={17} />
            <span>Fler avsnitt</span>
        </StyledToggle>
    );
};

export default EpisodePickerButton;
